<div class="d-flex flex-row align-items-center">
  <sb-button (click)="readFromClipboard()" classes="btn-primary mr-0">Zwischenablage einfügen</sb-button>
  <div class="ml-4 mr-4">
    <span>oder</span>
  </div>
  <sb-button (click)="addEmptyEntry()" classes="btn-primary">Eintrag hinzufügen</sb-button>
</div>

<div *ngIf="entries.length > 0" class="d-flex flex-column mt-4" style="gap: 0.5rem;">
  <div *ngFor="let entry of entries; let i = index" class="d-flex flex-row align-items-center">
    <input class="form-control" [value]="entry">
    <button class="btn btn-danger ml-1" (click)="delete(i)">
      <sb-icon icon="trash"></sb-icon>
    </button>
  </div>
</div>
